@if (isRmbRmc) {
<p>{{ "RENEWAL_TEXT" | globalTranslate }}</p>
} @if (isY('data.filing')) {
<div class="d-sm-block">
  <h1 class="person-label">{{ this.fullName }}</h1>
  <br />
</div>
}
<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  (validate)="onValidate($event)"
>
  <section formGroupName="data">
    @if (this.hideTopLevel) {
    <nh-field
      id="tf_filing"
      label="{{ 'TAX_FILING_STATIC_TEXT1' | globalTranslate }}"
      class="label-section"
      [col9]="true"
    >
      <select
        nhTranslate
        [attr.aria-label]="'TAX_FILING_STATIC_TEXT1' | globalTranslate"
        name="filing"
        id="filing"
        formControlName="filing"
        [items]="tableCodeValue('YESNO', 'data.filing')"
        (change)="onChangeTaxFiling()"
        aria-required="true"
      ></select>
    </nh-field>
    } @if ((isY('data.filing') || !this.hideTopLevel)) {
    <nh-field
      id="tf_taxFilingIndividualId"
      label="{{ 'TAX_FILING_STATIC_TEXT2' | globalTranslate }}"
      class="label-section"
      [col9]="true"
    >
      <div
        class="hint"
        [innerHTML]="'TAX_FILING_STATIC_TEXT3' | globalTranslate"
      ></div>
      <select
        nhTranslate
        [attr.aria-label]="'TAX_FILING_STATIC_TEXT2' | globalTranslate"
        name="taxFilingIndividualId"
        id="taxFilingIndividualId"
        formControlName="taxFilingIndividualId"
        bindLabel="name.fullName"
        bindValue="identifier"
        [items]="individuals"
        required
        (change)="resetTaxDependents()"
      ></select>
    </nh-field>
    } @if (isEnabled('data.jointFiler') && (isY('data.filing') ||
    !this.hideTopLevel)) {
    <nh-field
      id="tf_jointFiler"
      label="{{ 'DOES_2' | globalTranslate }}{{ this.fullName }} {{
        'TAX_FILING_STATIC_TEXT4' | globalTranslate
      }} {{ this.refFullname }}?"
      class="label-section"
    >
      <select
        nhTranslate
        [attr.aria-label]="
          ('DOES_2' | globalTranslate) +
          ' ' +
          this.fullName +
          ' ' +
          ('TAX_FILING_STATIC_TEXT4' | globalTranslate) +
          '' +
          this.refFullname
        "
        name="jointFiler"
        id="jointFiler"
        [items]="tableCodeValue('YESNO', 'data.jointFiler')"
        formControlName="jointFiler"
        (change)="resetTaxDependents()"
      ></select>
    </nh-field>
    }<br />

    @if ((this.showDependents || isEnabled('data.taxDependent')) &&
    (isY('data.filing') || !this.hideTopLevel)) {
    <div>
      <h2 class="section-header">
        {{ "TAX_FILING_STATIC_TEXT5" | globalTranslate }}
      </h2>
      <hr />
      <nh-field
        id="tf_taxDependent"
        label="{{ 'DOES_2' | globalTranslate }}{{ this.fullName }} {{
          'TAX_FILING_STATIC_TEXT6' | globalTranslate
        }}"
        class="label-section"
      >
        <select
          nhTranslate
          [attr.aria-label]="
            ('DOES_2' | globalTranslate) +
            '' +
            this.fullName +
            '' +
            ('TAX_FILING_STATIC_TEXT6' | globalTranslate)
          "
          name="taxDependent"
          id="taxDependent"
          [items]="tableCodeValue('YESNO', 'data.taxDependent')"
          formControlName="taxDependent"
          (change)="resetTaxDependents()"
          aria-required="true"
          aria-required="true"
        ></select>
      </nh-field>
    </div>
    } @if (isY('data.taxDependent')&& (isY('data.filing') ||
    !this.hideTopLevel)) {
    <div [formGroup]="getControl('data')">
      <div class="mb-2 pb-2 pt-2">
        <label class="label-section" for="taxDependents"
          ><span class="text-danger" aria-hidden="true">*</span
          >{{ "TAX_FILING_STATIC_TEXT7" | globalTranslate }} {{ fullName
          }}{{ "TAX_FILING_STATIC_TEXT8" | globalTranslate }}
        </label>
        @for (choice of checkboxList; track choice; let i = $index) {
        <div class="mt-2 pt-2">
          <div class="form-check pb-md-1 checkbox">
            <label class="form-check-label mt-2">
              <input
                id="{{ 'tf' + choice + i }}"
                type="checkbox"
                tabindex="0"
                [value]="choice.individualId"
                [attr.aria-label]="choice.prop"
                [attr.aria-required]="true"
                (click)="onCheckChange($event)"
                [checked]="choice.checked"
              />
              <span class="cr"
                ><i class="cr-icon fa fa-check" aria-hidden="true"></i></span
              >{{ choice.prop }}
            </label>
          </div>
        </div>
        } @if (getControl('data.taxDependents').status === 'INVALID') {
        <div>
          <nh-alert type="warning" [isOpen]="true">
            <div class="row">
              <div class="col-auto icon">
                <img
                  src="../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
                  alt=""
                />
              </div>
              <div class="col message">
                <span>{{ "REQUIRED" | globalTranslate }}</span>
              </div>
            </div>
          </nh-alert>
        </div>
        }
      </div>
    </div>
    }
  </section>
</nh-form>